import React, { useCallback, useEffect, useState } from "react";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import { TextInput } from "../UIkit";
import { makeStyles } from "@material-ui/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { useSelector, useDispatch } from "react-redux";
import { getUserId } from "../../reducks/users/selectors";
import { doc, deleteDoc, updateDoc, increment } from "firebase/firestore";
import { FirebaseTimestamp, db } from "../../firebase";
import { MinusIcon, PlusIcon } from "../Icons/CartIcons";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { addProductToCart } from "../../reducks/users/operations";
import { buildLineFromFavorite } from "../../functions/cart/cartLine";
import InternalCodeLabel from "./InternalCodeLabel";

const useStyles = makeStyles((theme) => ({
  list: {
    height: 220,
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      height: 300,
      overflowY: "auto",
    },
    [theme.breakpoints.between("sm", "md")]: {
      height: 300,
      width: 500,
      overflowY: "auto",
    },
    [theme.breakpoints.up("md")]: {
      height: 250,
      overflowY: "auto",
      width: 500,
    },
  },
  image: {
    objectFit: "cover",
    margin: 16,
    height: 96,
    width: 96,
  },
  text: {
    width: "100%",
  },
  amount: {
    display: "flex",
    alignItems: "center",
  },
  productName: {
    "& .MuiListItemText-primary": {
      fontSize: "0.8rem",
    },
  },
  quantityContents: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
  },
  quantityButton: {
    width: 24,
    background: "transparent",
    border: "none",
    cursor: "pointer",
  },
  "quantityButton svg": {
    color: "#c2773e",
  },
  "quantityButton:hover svg": {
    color: "#617d98",
  },
  unitPrice: {
    display: "inlin-block",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "14px",
    marginBottom: "4px",
    marginRight: "15px",
  },
  quantityOuterText: {
    // display:"flex",
    marginBottom: "6px",
    marginRight: "10px",
  },
  quantityInnerText: {
    // display:"flex",
    marginBottom: "6px",
    margin: "0 5px",
  },
  quantityCount: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  iconContents: {},
}));

const FavoriteListItem = (props) => {
  const classes = useStyles();
  // const selector =useSelector((state)=>state);
  const dispatch = useDispatch();
  const uid = useSelector(getUserId);
  const image = props.product.images[0].path;
  const name = props.product.name;
  const price = Number(props.product.price).toLocaleString();
  const priceInt = Number(props.product.price);
  const size = props.product.size;
  const quantity = props.product.quantity;
  const totalPrice = Number(props.product.totalPrice).toLocaleString();
  const [remarks, setRemarks] = useState(props.product.remarks || "");
  const [currentQuantity, setCurrentQuantity] = useState(
    props.product.quantity
  );
  const [currentTotalPrice, setCurrentTotalPrice] = useState(
    props.product.totalPrice
  );

  const removeProductFromfavorite = async (id) => {
    const favoriteItemRef = doc(db, "users", uid, "favorite", id);
    await deleteDoc(favoriteItemRef);
  };

  const inputRemarks = useCallback(
    async (event) => {
      setRemarks(event.target.value);
      const productRef = doc(
        db,
        "users",
        uid,
        "favorite",
        props.product.favoriteId
      );
      await updateDoc(productRef, { remarks: event.target.value });
      props.updateProductItem(
        event.target.value,
        currentQuantity,
        currentTotalPrice
      );
    },
    [setRemarks]
  );

  const handleIncrement = async (id) => {
    // 数量を増やす
    const newQuantity = currentQuantity + 1;
    const newTotalPrice = newQuantity * priceInt;
    setCurrentQuantity(newQuantity);
    setCurrentTotalPrice(newTotalPrice);
    props.updateProductItem(remarks, currentQuantity, currentTotalPrice);
    const productRef = doc(db, "users", uid, "favorite", id);
    await updateDoc(productRef, {
      quantity: newQuantity,
      totalPrice: newTotalPrice,
    });
  };

  const handleDecrement = async (id) => {
    if (props.product.quantity === 1) {
      // 数量が1の場合、削除処理を実行
      await removeProductFromfavorite(id);
      return;
    }
    // 数量を減らす
    const newQuantity = currentQuantity - 1;
    const newTotalPrice = newQuantity * priceInt;
    setCurrentQuantity(newQuantity);
    setCurrentTotalPrice(newTotalPrice);
    //props.updateProductItem(remarks, currentQuantity, currentTotalPrice);
    props.updateProductItem(remarks, newQuantity, newTotalPrice);
    const productRef = doc(db, "users", uid, "favorite", id);
    await updateDoc(productRef, {
      quantity: newQuantity,
      totalPrice: newTotalPrice,
    });
  };
  const handleAddProduct = () => {
    dispatch(
      addProductToCart(
        buildLineFromFavorite({
          favorite: props.product,
          quantity: currentQuantity,
          remarks,
          addedAt: FirebaseTimestamp.now(),
        })
      )
    );
  };

  return (
    <>
      <ListItem className={classes.list}>
        <ListItemAvatar>
          <img className={classes.image} src={image} alt="商品画像" />
        </ListItemAvatar>
        <div className={classes.text}>
          <InternalCodeLabel idin={props.product.idin} />
          <ListItemText
            className={classes.productName}
            primary={name}
            secondary={"サイズ:" + size}
          />
          {/* <div className={classes.amount}> */}
          <ListItemText
            primary={"￥" + totalPrice}
            // 数量: ${quantity}`}
          />
          <div className={classes.quantityContents}>
            {/* <ListItemText
                            secondary={"単価:￥" + price +  " 数量:" + quantity} 
                        /> */}
            <div className={classes.unitPrice}>{`単価:￥ ${price}`}</div>
            <div className={classes.quantityOuterText}>{`数量:`}</div>
            <div className={classes.quantityCount}>
              <button
                className={classes.quantityButton}
                onClick={() => handleDecrement(props.product.favoriteId)}
              >
                <MinusIcon />
              </button>
              <div className={classes.quantityInnerText}>{`${quantity}`}</div>
              <button
                className={classes.quantityButton}
                onClick={() => handleIncrement(props.product.favoriteId)}
              >
                <PlusIcon />
              </button>
            </div>
          </div>

          <TextInput
            fullWidth={true}
            label={"備考"}
            multiline={false}
            required={false}
            minRows={1}
            onChange={(event) => inputRemarks(event, props.product.favoriteId)}
            disabled={!props.isEnableRemarks}
            value={remarks}
            type={"text"}
          />
          {/* <ListItemText
                     secondary={"数量:" + quantity}
                /> */}
          {/* </div> */}
        </div>
        <div className={classes.iconContents}>
          <div>
            <IconButton
              onClick={() =>
                removeProductFromfavorite(props.product.favoriteId)
              }
            >
              <DeleteIcon />
            </IconButton>
          </div>
          <div>
            <IconButton onClick={() => handleAddProduct()}>
              <ShoppingCartIcon />
            </IconButton>
          </div>
        </div>
      </ListItem>
      <Divider />
    </>
  );
};

export default FavoriteListItem;
